import BaseModal from 'components/Modals/BaseModal';
import BuoyDeviceSettings from 'features/Integrations/features/ConnectedDevices/components/BuoyDeviceSettings';
import { Device } from 'features/Integrations/features/ConnectedDevices/types/MonitoringStation_types';

type Props = {
  device: Device | null;
  stageOpen: boolean;
  usgsOpen: boolean;
  onClearDeviceSettings: () => void;
};

export default function BuoyDeviceModal({ device, stageOpen, usgsOpen, onClearDeviceSettings }: Props) {
  return (
    <>
      <BaseModal
        show={!!device && !stageOpen && !usgsOpen}
        handleShow={onClearDeviceSettings}
        title={
          device ? `${device.alias || device.name || 'Buoy'} (${device.node_id})` : 'Buoy Settings'
        }
      >
        <BuoyDeviceSettings />
      </BaseModal>
    </>
  );
}
